import { Box, Grid } from '@mui/material';
import WhatsAppEditor from './WhatsAppEditor';
import WhatsAppPreview from './WhatsAppPreview';
import { styles } from '../styles';

type Props = {
    content: string;
    formattedPreviewContent: string;
    setContent: (content: string) => void;
};

const WhatsAppContentWrapper = ({ content, formattedPreviewContent, setContent }: Props) => (
    <Grid container spacing={3} sx={{ flexGrow: 1 }}>
        <Grid item xs={12} md={6}>
            <Box overflow="auto" paddingBottom={2} paddingRight={4} rowGap={3} sx={styles.container}>
                <WhatsAppEditor content={content} setContent={setContent} />
            </Box>
        </Grid>
        <Grid display="flex" justifyContent="center" item xs={12} md={6}>
            <WhatsAppPreview formattedContent={formattedPreviewContent} />
        </Grid>
    </Grid>
);

export default WhatsAppContentWrapper;
